import { defineComponent as h, ref as r, computed as b, watch as N, toRef as $, nextTick as f, h as a } from "vue";
const R = h({
  name: "SlotMachineNumber",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    value: {
      // could be '+', 1, 2, ...
      type: [Number, String],
      required: !0
    },
    oldOriginalNumber: {
      type: Number,
      default: void 0
    },
    newOriginalNumber: {
      type: Number,
      default: void 0
    }
  },
  setup(n) {
    const o = r(null), u = r(n.value), s = r(n.value), i = r("up"), t = r(!1), d = b(() => t.value ? `${n.clsPrefix}-base-slot-machine-current-number--${i.value}-scroll` : null), c = b(() => t.value ? `${n.clsPrefix}-base-slot-machine-old-number--${i.value}-scroll` : null);
    N($(n, "value"), (e, l) => {
      u.value = l, s.value = e, f(v);
    });
    function v() {
      const e = n.newOriginalNumber, l = n.oldOriginalNumber;
      l === void 0 || e === void 0 || (e > l ? m("up") : l > e && m("down"));
    }
    function m(e) {
      i.value = e, t.value = !1, f(() => {
        var l;
        (l = o.value) === null || l === void 0 || l.offsetWidth, t.value = !0;
      });
    }
    return () => {
      const {
        clsPrefix: e
      } = n;
      return a("span", {
        ref: o,
        class: `${e}-base-slot-machine-number`
      }, u.value !== null ? a("span", {
        class: [`${e}-base-slot-machine-old-number ${e}-base-slot-machine-old-number--top`, c.value]
      }, u.value) : null, a("span", {
        class: [`${e}-base-slot-machine-current-number`, d.value]
      }, a("span", {
        ref: "numberWrapper",
        class: [`${e}-base-slot-machine-current-number__inner`, typeof n.value != "number" && `${e}-base-slot-machine-current-number__inner--not-number`]
      }, s.value)), u.value !== null ? a("span", {
        class: [`${e}-base-slot-machine-old-number ${e}-base-slot-machine-old-number--bottom`, c.value]
      }, u.value) : null);
    };
  }
});
export {
  R as default
};
